module.exports = __webpack_public_path__ + "static/media/feature-5.d7aaf72b.jpg";